module.exports = __webpack_public_path__ + "img/rulePopupTitle.a4d7bc8e.png";